import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@shared/ui/molecules/Dialog';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import TextField from '@shared/ui/atoms/TextField';
import { createCompany, selectIsSetupCompanyProcessing, selectIsSetupCompanySuccess } from '@features/settings/store/setupCompany.duck';
import { closeDialog } from '@shared/store/dialog.duck';
import './setup-company-dialog.scss';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import DialogHeader from '@shared/dialogs/DialogHeader';
import styled from 'styled-components';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { useTranslation } from "react-i18next";
import { DialogIdentifiers, openDialog } from "../../store/dialog.duck";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function SetupCompanyDialog() {
  const dispatch = useDispatch();
  const isProcessing = useSelector(selectIsSetupCompanyProcessing);
  const successful = useSelector(selectIsSetupCompanySuccess);

  const close = () => {
    dispatch(closeDialog());
  }

  return (
    <Dialog isOpen={true} onClose={() => close()}>
      <div className="setupCompanyDialog">
        { isProcessing && <LoadingSpinner hideBorder={true}/> }
        { successful && <SetupCompanyComplete close={close} /> }
        { (!isProcessing && !successful) && <SetupCompanyInput /> }
      </div>
    </Dialog>
  )
}

function SetupCompanyInput() {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [companyName, setCompanyName] = useState('');
  return (
    <React.Fragment>
      <HeadlineLarge className="setupCompanyDialog__title">{t('settings.setup-a-company')}</HeadlineLarge>
      <TextField dataTest="setupCompanyDialogCompanyInput" onChange={setCompanyName} label="settings.company-name" value={companyName} />
      <PrimaryButton dataTest="setupCompanyDialogCreateButton"
                     size={ButtonSize.Large}
                     fullWidth={true}
                     text="button.create-company"
                     click={() => dispatch(createCompany(companyName))} />
    </React.Fragment>
  )
}

function SetupCompanyComplete(props: {close: () => any}) {
  const dispatch = useDispatch();
  const setupOtherTeams = () => {
    props.close();
    dispatch(openDialog(DialogIdentifiers.CreateTeamDialog));
  }
  return (
    <React.Fragment>
      <DialogHeader title="dialog-headers.company-created" icon={IconTypes.Tick} image="/assets/images/woman-laptop-no-speech-bubble.svg" />
      <SetupCompanyButton dataTest="setupCompanyDialogTeamsButton" size="large" fullWidth={true} text="button.setup-more-teams" click={() => setupOtherTeams()} />
      <SetupCompanyOutlineButton dataTest="setupCompanyDialogCloseButton" size="large" fullWidth={true} text="button.done-for-now" click={() => props.close()} />
    </React.Fragment>
  )
}

const SetupCompanyButton = styled(PrimaryButton)<any>`
  margin-bottom: 24px;
`

const SetupCompanyOutlineButton = styled(OutlineButton)<any>`
  margin-bottom: 24px;
`
